import API from './h5/data.js';
import FLIB from './h5/funlibs.js';
import Report from './h5/report';
import Dialog from '@tencent/wxgamelib/common/uiutil.popup.src.js';

export { API, FLIB, Report, Dialog };

export default {
  API,
  FLIB,
  Report,
  Dialog
};
